export const content = {
  keineRückmeldung: 'Keine Rückmeldung vorhanden',
  angebotAbgelehnt: 'Angebot abgelaufen / abgelehnt',
  ausschreibungAbgelehnt: 'Abgelehnt',
  ausschreibungOderAngebotAbgelehnt: 'Mindestens ein/e Ausschreibung/Angebot ist abgelaufen oder wurde abgelehnt',
  antwortMitVorbehalt: 'Antwort mit Vorbehalt',
  angebotAngenommen: 'Angebot angenommen',
  ausschreibungAngenommen: 'Auf Ausschreibung beworben',
  ausschreibungOderAngebotAngenommen: 'Alle Angebote angenommen / Auf Ausschreibung beworben',
};
